import React, { ReactNode, useMemo } from 'react';
import { useAccess } from '@hiiretail/core';

type AccessControlProps = {
  permission?: string | string[];
  renderIfNoAccess: ReactNode;
};

type AccessControlComponent = React.FC<AccessControlProps>;

type checkFunction = (val: string) => boolean;
type runCheckOverArrayFunction = (checkFn: checkFunction, input?: string[] | string) => boolean;

export const AccessControl: AccessControlComponent = ({
  children,
  permission,
  renderIfNoAccess,
}) => {
  const { hasPermission } = useAccess();

  const runCheckOverArray: runCheckOverArrayFunction = (checkFn, input) => {
    let arr: string[] = [];
    if (typeof input === 'string') {
      arr = [input];
    } else if (input) {
      arr = input;
    }

    return !arr.length || arr.some((value) => checkFn(value));
  };

  const hasAccess = useMemo(
    () => permission === '' ? true : runCheckOverArray(hasPermission, permission),
    [hasPermission, permission],
  );

  return hasAccess ? (children as React.ReactElement) : (renderIfNoAccess as React.ReactElement);
};
